import { BundleChangeRequestResource } from 'app/_resources/bundle-change-request.resource';
import { BundleRequestService } from 'app/_services/bundle-request.service';
import { ErrorHandler } from 'app/_services/error-handler.factory';
import { NetworkPointResource } from 'app/_resources/network-point.resource';
import { AuthService } from 'app/_services/auth.service';
import { Growl } from 'angular/custom/services/growl.service';
import * as angular from 'angular';

class NetworkPointBundleCreatePageCtrl implements ng.IController {
    constructor(
        private bundleChangeRequestResource: BundleChangeRequestResource,
        private bundleRequestService: BundleRequestService,
        private errorHandler: ErrorHandler,
        private $window: ng.IWindowService,
        private $filter: ng.IFilterService,
        private NetworkPoint: NetworkPointResource,
        private authService: AuthService,
        private growl: Growl,
        private $q: ng.IQService,
        private $location: ng.ILocationService
    ) {}

    public isCreateMode: boolean;
    public isDetailsMode: boolean;
    public isConversationMode: boolean;
    public isInitialMode: boolean;
    public isDeleteMode: boolean;
    public networkPointForCreation: NetworkPointDto;
    public form: ng.IFormController;
    public submitting: boolean;
    public id: number;
    public networkPoint: NetworkPointDto;
    public networkPoint0: NetworkPointDto;
    public networkPoint1: NetworkPointDto;
    public bundleRequest: BundleChangeRequestDto = <BundleChangeRequestDto>{
        floatingTariff: true
    };
    public bundleRequestConversation: BundleChangeRequestDto[];
    public commentHistory: any[] = [];
    public loggedInUser: LoginResult;
    public editableDirection: Direction;
    public useShortTermForLongTerm: boolean = this.isCreateMode;
    public oneToNbundle: boolean = false;
    public uiLoading: boolean = true;
    public uiLoadingNwp: boolean = true;
    public uiLoadingError: boolean = false;
    public uiReadOnly: boolean;
    public uiSent: boolean;

    $onInit() {
        if (!this.isCreateMode) {
            this.isCreateMode =
                this.$location.path().indexOf('/network-point/bundle/create') >
                -1;
        }
        if (!this.isDetailsMode) {
            this.isDetailsMode =
                this.$location.path().indexOf('/network-point/bundle/details') >
                -1;
        }
        if (!this.isConversationMode) {
            this.isConversationMode =
                this.$location
                    .path()
                    .indexOf('/network-point/bundle/conversation') > -1;
        }
        if (!this.isInitialMode) {
            this.isInitialMode =
                this.$location.path().indexOf('/network-point/bundle/change') >
                -1;
        }
        if (!this.isDeleteMode) {
            this.isDeleteMode =
                this.$location.path().indexOf('/network-point/bundle/delete') >
                -1;
        }

        this.authService.userLoginPromise.promise.then(
            (loginResult: LoginResult) => {
                if (!!loginResult) {
                    this.loggedInUser = loginResult;
                }
            }
        );

        //Determine the mode
        if (
            this.isConversationMode ||
            this.isInitialMode ||
            this.isDeleteMode ||
            this.isDetailsMode
        ) {
            this.getBundleRequestForConversation(this.id);
            if (this.isInitialMode || this.isDeleteMode) {
                this.checkOneToNBundleSituation(this.id);
            }
        } else if (this.isCreateMode && this.networkPointForCreation) {
            this.bundleRequest.requestingTsoRefId =
                this.networkPointForCreation.tso0Id;
            this.bundleRequest.operation = 'CREATE';
            this.bundleRequest.state = 'REQUESTED';
            this.bundleRequest.entryOrderLongTerm = [];
            this.bundleRequest.exitOrderLongTerm = [];
            this.bundleRequest.entryOrderShortTerm = [];
            this.bundleRequest.exitOrderShortTerm = [];
            this.bundleRequest.slotAssignmentsLongTerm = [];
            this.bundleRequest.slotAssignmentsShortTerm = [];
            this.getNetworkPoint(
                this.networkPointForCreation.id,
                this.networkPointForCreation.direction
            ).finally(() => (this.uiLoading = false));
        }
    }

    private isUserPartOfBundle(): boolean {
        if (this.isCreateMode) {
            return true;
        }
        if (!this.uiLoading) {
            return (
                this.loggedInUser.referenceId == this.networkPoint0.tso0Id ||
                this.loggedInUser.referenceId == this.networkPoint1.tso0Id
            );
        }
    }

    private checkOneToNBundleSituation(id) {
        this.NetworkPoint.findBundleSituationForBundlePoint(
            { refId: id },
            (res: BundleDto) => {
                if (res.bundlingSituation && res.bundlingSituation.length > 2) {
                    this.oneToNbundle = true;
                }
            },
            this.errorHandler
        );
    }

    public getBundleRequestForConversation(id) {
        if (this.isConversationMode) {
            this.bundleChangeRequestResource.getBundleRequestConversation(
                { conversationId: id },
                (res: BundleChangeRequestDto[]) => {
                    this.bundleRequestConversation = this.$filter('orderBy')(
                        res,
                        'createdAt'
                    );
                    this.bundleRequest = angular.copy(
                        this.bundleRequestConversation[
                            this.bundleRequestConversation.length - 1
                        ]
                    );
                    this.bundleRequest.messageToResponder = '';
                    this.uiReadOnly =
                        !this.bundleRequestService.canProcessConversation(
                            this.bundleRequest,
                            this.loggedInUser.referenceId
                        ) ||
                        this.bundleRequest.state == 'CONFIRMED' ||
                        this.bundleRequest.state == 'REJECTED' ||
                        this.bundleRequest.operation == 'DELETE';

                    let nwp0Promise = this.getNetworkPoint(
                        this.bundleRequest.exitPointRefId,
                        'EXIT'
                    );
                    let nwp1Promise = this.getNetworkPoint(
                        this.bundleRequest.entryPointRefId,
                        'ENTRY'
                    );

                    let promises = [nwp0Promise, nwp1Promise];

                    this.$q.all(promises).then(() => {
                        if (
                            this.networkPoint0.tso0Id ==
                            this.loggedInUser.referenceId
                        ) {
                            this.editableDirection = 'EXIT';
                        }
                        if (
                            this.networkPoint1.tso0Id ==
                            this.loggedInUser.referenceId
                        ) {
                            this.editableDirection = 'ENTRY';
                        }
                        if (
                            this.networkPoint0.tso0Id ==
                                this.loggedInUser.referenceId &&
                            this.networkPoint1.tso0Id ==
                                this.loggedInUser.referenceId
                        ) {
                            this.editableDirection = 'BUNDLE';
                        }
                        this.extractMessageConversationFromBundleRequests(
                            this.bundleRequestConversation
                        );
                        this.useShortTermForLongTerm =
                            this.bundleRequestService.compareSlotOrders(
                                this.bundleRequest
                            );

                        this.uiLoading = false;
                    });
                },
                this.errorHandler
            );
        }
        if (this.isInitialMode || this.isDeleteMode || this.isDetailsMode) {
            this.bundleChangeRequestResource.getInitialBundleChangeRequest(
                { bundleRefId: id },
                (res: BundleChangeRequestDto) => {
                    this.bundleRequest = res;
                    let nwp0Promise = this.getNetworkPoint(
                        this.bundleRequest.exitPointRefId,
                        'EXIT'
                    );
                    let nwp1Promise = this.getNetworkPoint(
                        this.bundleRequest.entryPointRefId,
                        'ENTRY'
                    );

                    let promises = [nwp0Promise, nwp1Promise];

                    this.$q.all(promises).then(() => {
                        if (
                            this.networkPoint0.tso0Id ==
                            this.loggedInUser.referenceId
                        ) {
                            this.editableDirection = 'EXIT';
                        }
                        if (
                            this.networkPoint1.tso0Id ==
                            this.loggedInUser.referenceId
                        ) {
                            this.editableDirection = 'ENTRY';
                        }
                        if (
                            this.networkPoint0.tso0Id ==
                                this.loggedInUser.referenceId &&
                            this.networkPoint1.tso0Id ==
                                this.loggedInUser.referenceId
                        ) {
                            this.editableDirection = 'BUNDLE';
                        }

                        this.extractMessageConversationFromBundleRequests(
                            this.bundleRequestConversation
                        );
                        this.useShortTermForLongTerm =
                            this.bundleRequestService.compareSlotOrders(
                                this.bundleRequest
                            );
                        this.uiLoading = false;

                        if (this.isDeleteMode) {
                            this.bundleRequest.operation = 'DELETE';
                            this.uiReadOnly = true;
                        }
                        if (this.isDetailsMode || this.isInitialMode) {
                            this.uiReadOnly = true;
                            this.networkPoint = <NetworkPointDto>{
                                bundled: true,
                                tso0Id: this.networkPoint0.tso0Id,
                                tso0LogoSmallUrl:
                                    this.networkPoint0.tso0LogoSmallUrl,
                                tso1Id: this.networkPoint1.tso0Id,
                                tso1LogoSmallUrl:
                                    this.networkPoint1.tso0LogoSmallUrl
                            };
                        }
                        if (this.isInitialMode) {
                            // Overwrite previous state
                            // TODO: Move uiReadonly to mode determination and join
                            //        this case with previous case for bundle information
                            this.uiReadOnly = false;
                        }
                    });
                },
                this.errorHandler
            );
        }
    }

    private getNetworkPointFromBundleRequest(
        bundleRequest: BundleChangeRequestDto,
        isInitiator: boolean
    ): NetworkPointDto {
        if (bundleRequest.requestingTsoRefId == this.networkPoint0.tso0Id) {
            if (isInitiator) {
                return this.networkPoint0;
            } else {
                return this.networkPoint1;
            }
        } else if (
            this.bundleRequestConversation[0].requestingTsoRefId ==
            this.networkPoint1.tso0Id
        ) {
            if (isInitiator) {
                return this.networkPoint1;
            } else {
                return this.networkPoint0;
            }
        }
    }

    public extractMessageConversationFromBundleRequests(bundleRequests): void {
        angular.forEach(bundleRequests, (bundleRequest, key) => {
            let comment = {
                tso: this.getNetworkPointFromBundleRequest(
                    bundleRequest,
                    key % 2 == 0
                ).tso0Name,
                direction: this.getNetworkPointFromBundleRequest(
                    bundleRequest,
                    key % 2 == 0
                ).direction,
                comment: bundleRequest.messageToResponder,
                timestamp: bundleRequest.changedAt
            };
            this.commentHistory.push(comment);
        });
    }

    public getNetworkPoint(id, direction): ng.IPromise<NetworkPointDto> {
        let param = {
            id: id,
            detailLevel: 'MINIMAL'
        };
        return this.NetworkPoint.get(
            param,
            (res: NetworkPointDto) => {
                if (direction == 'EXIT') {
                    this.networkPoint0 = res;
                    this.bundleRequest.exitPointRefId = this.networkPoint0.id;
                } else {
                    this.networkPoint1 = res;
                    this.bundleRequest.entryPointRefId = this.networkPoint1.id;
                }
            },
            this.errorHandler
        ).$promise;
    }

    public submit(
        form: ng.IFormController,
        newState: ProcessingState,
        oldState: ProcessingState
    ): boolean {
        this.form.$submitted = true;

        if (!form.$valid && this.bundleRequest.operation != 'DELETE') {
            this.growl.show(
                'Validation error: Please check all mandatory fields.',
                'danger'
            );
            return false;
        }

        if (this.useShortTermForLongTerm) {
            this.bundleRequest.slotAssignmentsLongTerm =
                this.bundleRequestService.copyShortTermToLongTermSlotAssignments(
                    this.bundleRequest.slotAssignmentsShortTerm
                );
            this.bundleRequest.exitOrderLongTerm = angular.copy(
                this.bundleRequest.exitOrderShortTerm
            );
            this.bundleRequest.entryOrderLongTerm = angular.copy(
                this.bundleRequest.entryOrderShortTerm
            );
        }

        if (
            this.bundleRequest.operation != 'DELETE' &&
            this.bundleRequestService.getAllBundledSlotsFromSlotAssignments(
                this.bundleRequest.slotAssignmentsShortTerm,
                'SHORT_TERM'
            ).length <= 0
        ) {
            this.growl.show(
                'Validation error: Please configure at least 1 bundled slot for short term.',
                'danger'
            );
            return false;
        }

        if (
            this.bundleRequest.operation != 'DELETE' &&
            this.bundleRequestService.getAllBundledSlotsFromSlotAssignments(
                this.bundleRequest.slotAssignmentsLongTerm,
                'LONG_TERM'
            ).length <= 0
        ) {
            this.growl.show(
                'Validation error: Please configure at least 1 bundled slot for long term.',
                'danger'
            );
            return false;
        }

        this.bundleRequest.state = newState;

        if (this.bundleRequest.id) {
            this.bundleRequest.parentBundleChangeRequestId =
                this.bundleRequest.id;
        }

        if (this.networkPoint0.tso0Id != this.loggedInUser.referenceId) {
            this.bundleRequest.responderTsoRefId = this.networkPoint0.tso0Id;
        }

        if (this.networkPoint1.tso0Id != this.loggedInUser.referenceId) {
            this.bundleRequest.responderTsoRefId = this.networkPoint1.tso0Id;
        }

        this.bundleRequest.senderTsoRefId = this.loggedInUser.referenceId;

        if (this.isCreateMode || this.isInitialMode || this.isDeleteMode) {
            this.sendBundleChangeRequest(oldState);
        }
        if (this.isConversationMode) {
            if (this.bundleRequest.state == 'COUNTER_PROPOSED') {
                if (
                    this.loggedInUser.referenceId == this.networkPoint0.tso0Id
                ) {
                    this.bundleRequest.responderTsoRefId =
                        this.networkPoint1.tso0Id;
                }
                if (
                    this.loggedInUser.referenceId == this.networkPoint1.tso0Id
                ) {
                    this.bundleRequest.responderTsoRefId =
                        this.networkPoint0.tso0Id;
                }
            }
            this.sendBundleChangeRequest(oldState);
        }
        return true;
    }

    private rejectAccept(form: ng.IFormController) {
        this.submit(form, 'REJECTED', this.bundleRequest.state);
    }

    private sendBundleChangeRequest(oldState: ProcessingState): void {
        this.submitting = true;
        if (
            this.bundleRequestService.isIntraTsoBundle(
                this.networkPoint0,
                this.networkPoint1
            )
        ) {
            this.NetworkPoint.createIntraTsoBundle(
                this.bundleRequest,
                (res) => {
                    this.growl.show('Bundle successfully created.', 'success');
                    this.uiSent = true;
                    this.submitting = false;
                },
                (err) => {
                    this.bundleRequest.state = oldState;
                    this.errorHandler(err);
                    this.submitting = false;
                }
            );
        } else {
            this.bundleChangeRequestResource.createBundleChangeRequest(
                this.bundleRequest,
                (res) => {
                    this.growl.show(
                        'Bundle request successfully sent.',
                        'success'
                    );
                    this.uiSent = true;
                    this.submitting = false;
                },
                (err) => {
                    this.bundleRequest.state = oldState;
                    this.bundleRequest.responderTsoRefId =
                        this.loggedInUser.referenceId;
                    this.errorHandler(err);
                    this.submitting = false;
                }
            );
        }
    }

    public undoChanges() {
        this.bundleRequest = angular.copy(
            this.bundleRequestConversation[
                this.bundleRequestConversation.length - 1
            ]
        );
        this.bundleRequest.messageToResponder = '';
    }

    public goBack(): void {
        this.$window.history.back();
    }
}

angular.module('app').component('pkpNetworkPointBundleCreatePage', {
    controller: NetworkPointBundleCreatePageCtrl,
    template:
        require('app/network-point-bundle/network-point-bundle-create.component.html'),
    bindings: {
        id: '<?',
        networkPointForCreation: '<?',
        isCreateMode: '<?',
        isDetailsMode: '<?',
        isConversationMode: '<?',
        isInitialMode: '<?',
        isDeleteMode: '<?'
    }
});
